// Fechas YYYY-MM-DD en la zona del navegador. toISOString() da la fecha UTC:
// en Costa Rica (UTC-6), desde las 18:00 ya devuelve el día siguiente.
const dos = n => String(n).padStart(2, "0");

export function fechaLocalISO(d = new Date()) {
  return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}`;
}

export function haceDiasISO(dias, desde = new Date()) {
  const d = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate() - dias);
  return fechaLocalISO(d);
}
